import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-265c4709"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pdf-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_counter_start = _resolveComponent("page-counter-start")!
  const _component_Cover = _resolveComponent("Cover")!
  const _component_Arbeitsflaeche = _resolveComponent("Arbeitsflaeche")!
  const _component_Zuwegung = _resolveComponent("Zuwegung")!
  const _component_Seilzugflaechen = _resolveComponent("Seilzugflaechen")!
  const _component_Schutzgerueste = _resolveComponent("Schutzgerueste")!
  const _component_Fremdleitung = _resolveComponent("Fremdleitung")!
  const _component_Anmerkungen = _resolveComponent("Anmerkungen")!
  const _component_page_counter_end = _resolveComponent("page-counter-end")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_page_counter_start),
    _createVNode(_component_Cover, {
      ba: _ctx.ba,
      immobilie: _ctx.immobilie,
      lang: _ctx.lang
    }, null, 8, ["ba", "immobilie", "lang"]),
    _createVNode(_component_Arbeitsflaeche, {
      ba: _ctx.ba,
      immobilie: _ctx.immobilie,
      lang: _ctx.lang
    }, null, 8, ["ba", "immobilie", "lang"]),
    _createVNode(_component_Zuwegung, {
      ba: _ctx.ba,
      immobilie: _ctx.immobilie,
      lang: _ctx.lang
    }, null, 8, ["ba", "immobilie", "lang"]),
    _createVNode(_component_Seilzugflaechen, {
      ba: _ctx.ba,
      immobilie: _ctx.immobilie,
      lang: _ctx.lang
    }, null, 8, ["ba", "immobilie", "lang"]),
    _createVNode(_component_Schutzgerueste, {
      ba: _ctx.ba,
      immobilie: _ctx.immobilie,
      lang: _ctx.lang
    }, null, 8, ["ba", "immobilie", "lang"]),
    _createVNode(_component_Fremdleitung, {
      ba: _ctx.ba,
      immobilie: _ctx.immobilie,
      lang: _ctx.lang
    }, null, 8, ["ba", "immobilie", "lang"]),
    _createVNode(_component_Anmerkungen, {
      ba: _ctx.ba,
      immobilie: _ctx.immobilie,
      lang: _ctx.lang
    }, null, 8, ["ba", "immobilie", "lang"]),
    _createVNode(_component_page_counter_end)
  ]))
}